import { motion, useReducedMotion } from 'motion/react';
import { Quotes, Star } from '@phosphor-icons/react';
import { SpotlightCard } from './motion/SpotlightCard';

const testimonials = [
  {
    quote:
      "Our solicitor went quiet for a week during our house purchase. I CC'd Chase it for me and it kept nudging them until we got the completion date confirmed. Honestly saved us days in the chain.",
    name: 'Emma R.',
    role: 'First-time home buyer',
    initials: 'ER',
  },
  {
    quote:
      "I had an invoice sitting unpaid for three weeks. Chased it for me followed up twice, politely but firmly, and I got paid within days without having to write a single awkward email myself.",
    name: 'James O.',
    role: 'Freelance designer',
    initials: 'JO',
  },
  {
    quote:
      "Applied for a role and heard nothing back for two weeks. Set up a follow-up, forgot about it, and got a reply from the recruiter a few days later asking to schedule an interview.",
    name: 'Priya K.',
    role: 'Job seeker',
    initials: 'PK',
  },
];

function TestimonialCard({ testimonial, index }) {
  const reduce = useReducedMotion();

  return (
    <motion.div
      variants={{
        hidden: reduce ? {} : { opacity: 0, y: 24 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } },
      }}
    >
      <SpotlightCard className="h-full rounded-xl border border-white/10 bg-white/[0.04] p-6 transition-colors duration-300 hover:border-white/20">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-500/15">
          <Quotes weight="fill" className="h-5 w-5 text-indigo-300" />
        </div>

        <div className="mt-4 flex gap-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <motion.span
              key={i}
              initial={reduce ? false : { opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 0.3, delay: reduce ? 0 : 0.4 + index * 0.1 + i * 0.06 }}
            >
              <Star weight="fill" className="h-4 w-4 text-amber-400" />
            </motion.span>
          ))}
        </div>

        <p className="mt-4 text-sm leading-relaxed text-zinc-300">"{testimonial.quote}"</p>

        <div className="mt-6 flex items-center gap-3">
          <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-indigo-500/15 text-xs font-semibold text-indigo-300">
            {testimonial.initials}
          </div>
          <div>
            <p className="text-sm font-semibold text-zinc-100">{testimonial.name}</p>
            <p className="text-xs text-zinc-500">{testimonial.role}</p>
          </div>
        </div>
      </SpotlightCard>
    </motion.div>
  );
}

export function Testimonials() {
  const reduce = useReducedMotion();

  return (
    <section className="py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="mb-4 text-center text-3xl font-bold text-zinc-100 md:text-4xl">Loved by people done with chasing</h2>
        <p className="mx-auto mb-16 max-w-xl text-center text-lg text-zinc-400">
          Real follow-ups, handled quietly in the background.
        </p>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          variants={{ hidden: {}, visible: { transition: { staggerChildren: reduce ? 0 : 0.12 } } }}
          className="grid gap-5 md:grid-cols-3"
        >
          {testimonials.map((testimonial, i) => (
            <TestimonialCard key={testimonial.name} testimonial={testimonial} index={i} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
